import { Box, Typography } from '@mui/material';
import { styled } from '@mui/styles';
import React from 'react';

const HighlightBox = ({ children }: React.PropsWithChildren<unknown>) => {
  return (
    <StyledHighlightBox>
      {React.Children.map(children, (kid) => (
        <ChangedField variant="body2">{kid}</ChangedField>
      ))}
    </StyledHighlightBox>
  );
};

const StyledHighlightBox = styled(Box)(() => ({
  backgroundColor: 'rgba(191, 64, 64, 0.2)',
  borderRadius: '16px',
  padding: '6px 12px',
  display: 'inline-flex',
  flexWrap: 'wrap',
  flexDirection: 'column',
}));

const ChangedField = styled(Typography)(() => ({
  color: 'rgba(191, 64, 64, 1)',
}));

export { HighlightBox };
